<script>
import { toRefs } from "vue";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
export default {
	props: [
		"progress",
		"isAnimated",
		"isDouble",
		"href1",
		"href2",
		"GAData1",
		"GAData2",
	],
	setup(props) {
		const { GAData1, GAData2 } = toRefs(props);

		gsap.registerPlugin(ScrollToPlugin);
		const goAnchor = (id, e) => {
			e.preventDefault();
			gsap.to(document.body, {
				scrollTo: { y: id, offset: "100", autoKill: true },
				ease: "power2.inOut",
				duration: 1.5,
			});
		};

		return {
			goAnchor,
			GAData1,
			GAData2,
		};
	},
};
</script>

<template>
	<div class="CTA-button">
		<transition name="fade">
			<a
				class="single"
				v-show="!isDouble"
				:href="`${href1 || ''}`"
				v-sendGAsignal="GAData1"
				@click="goAnchor('#form', $event)"
			>
				<span class="text_ch_medium"><slot></slot></span>
			</a>
		</transition>
		<transition name="fade">
			<a
				class="double"
				v-show="isDouble"
				:href="`${href1 || ''}`"
				target="_blank"
				v-sendGAsignal="GAData1"
			>
				<span class="text_ch_medium">瞭解更多</span>
			</a>
		</transition>
		<transition name="fade">
			<span class="seperator" v-show="isDouble">|</span>
		</transition>
		<transition name="fade">
			<a
				class="double"
				v-show="isDouble"
				:href="`${href2 || ''}`"
				v-sendGAsignal="GAData2"
				@click="goAnchor('#form', $event)"
			>
				<span class="text_ch_medium">預約賞車</span>
			</a>
		</transition>
		<div class="border left"></div>
		<div class="border right"></div>
		<div class="border bottom"></div>
		<div class="button_border-bottom"></div>
		<div
			:class="[
				'button_border-bottom',
				'pgBar',
				{ isAnimated: isAnimated },
			]"
			:style="{ width: `${progress}%` }"
		></div>
	</div>
</template>

<style lang="sass">
.CTA-button
    position: absolute
    bottom: calc(3.125vw + 6px)
    // width: calc(10.5vw + 199.2px)
    width: 400px
    // height: calc(1.4vw + 31.6px)
    height: 58px
    background-image: linear-gradient(to bottom, rgba(#fff, 0), rgba(#ffe8c9, 0.3) 50%, rgba(#ffe8c9, 0.6))
    z-index: 1000
    .single, .double
        display: inline-block
        position: absolute
        width: 100%
        height: 100%
        left: 0
        top: 0
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25)
        // font-size: 1.5rem
        font-size: 15px
        // line-height: calc(1.4vw + 31.6px)
        line-height: 58px
        letter-spacing: 3.15px
        text-align: center
        user-select: none
        cursor: pointer
        text-decoration: none
        &:hover
            background-image: linear-gradient(to bottom, rgba(#fff, 0), rgba(#ffe8c9, 0.45) 50%, rgba(#ffe8c9, 0.75))
        &:active
            background-image: linear-gradient(to bottom, rgba(#fff, 0), rgba(#ffe8c9, 0.45) 50%, rgba(#ffe8c9, 0.75))
    .double
        width: 50%
    .double:nth-child(4)
        left: 50%
    span
        height: 100%
        font-size: inherit
        &.seperator
            position: absolute
            left: 50%
            top: 50%
            transform: translate(-50%, -50%)
            text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6)
            // font-size: 1.5rem
            font-size: 15px
            line-height: 58px
            letter-spacing: 3.15px
            text-align: center
    .border
        position: absolute
        width: 1px
        height: 100%
        opacity: 0.5
        background: linear-gradient(to bottom, rgba(#fff, 0), #c1c1c1)
        &.left
            left: 0
            top: 0
        &.right
            right: 0
            top: 0
        &.bottom
            height: 1px
            width: 100%
            bottom: 0
            background: none
            background-color: #c1c1c1
    .button_border-bottom
        position: absolute
        top: 100%
        // width: calc(10.5vw + 199.2px)
        width: 100%
        left: 0
        height: 6px
        background-image: url("~@/assets/color-bar.png")
        background-size: 100% auto
        opacity: 0.6
        &.pgBar
            opacity: 1
            background-repeat: repeat-x
            background-position: 0 0
            animation: color-bar-loop 2.5s linear infinite forwards
            background-size: 400px 6px
        &.isAnimated
            transition: 1s linear

.fade-enter-active, .fade-leave-active
    transition: opacity 0.3s ease
.fade-enter-from, .fade-leave-to
    opacity: 0
.fade-enter-to, .fade-leave-from
    transition-delay: 0.3s
    opacity: 1


@keyframes color-bar-loop
    0%
        background-position: 0 0
    100%
        background-position: 400px 0

@media screen and (max-width: 1600px)
    .CTA-button
        transform: scale(0.9)
        transform-origin: center bottom
@media screen and (max-width: 1200px)
    .CTA-button
        transform: scale(0.8)
@media screen and (max-width: 800px)
    .CTA-button
        transform: scale(0.7)

@media screen and (max-width: 768px)
    .CTA-button
        bottom: 75px
        transform: scale(0.6)
        .single, .double
            font-size: calc(1.2rem / 0.65)
            letter-spacing: 1.8px
            span
                &.seperator
                    font-size: calc(1.3rem / 0.65)
                    letter-spacing: 1.8px
        .border
            width: calc(0.5px / 0.65)
            &.bottom
                height: calc(0.5px / 0.65)
        .button_border-bottom
            height: calc(3px / 0.65)
</style>
